import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      const copied = button.dataset.clipboardCopiedLabel
      // Skip if there is no label, or a swap is already in progress (avoids a
      // double-click race that would leave the button stuck on the copied label).
      if (!copied || button.dataset.clipboardOriginalLabel) return
      button.dataset.clipboardOriginalLabel = button.textContent
      button.textContent = copied
      setTimeout(() => {
        button.textContent = button.dataset.clipboardOriginalLabel
        delete button.dataset.clipboardOriginalLabel
      }, 1500)
    }).catch(() => {})
  }
}
